import React from "react";

export function LocalKnobNumberInput({
  value,
  onChange,
  onBlur,
  disabled = false,
  min,
  max,
  step,
  placeholder,
  title,
  className = "",
  tabIndex = 0,
}) {
  return (
    <input
      type="number"
      value={value}
      min={min}
      max={max}
      step={step}
      placeholder={placeholder}
      title={title}
      disabled={disabled}
      tabIndex={tabIndex}
      onChange={(e) => onChange?.(e.target.value)}
      onBlur={(e) => onBlur?.(e.target.value)}
      className={[
        "ai-chat-local-knob-number",
        className,
      ].join(" ")}
    />
  );
}

